export default __webpack_public_path__ + "static/media/file.d517436f.svg";